import React from "react";
import { useHistory } from "react-router-dom";

export const PerformanceComponent = () => {
  const history = useHistory();
  const performance = () => {
    history.push("/performance");
  };
  return (
    <div className="text-align-center" onClick={performance}>
      <span className="font-size-smd bold font-family-default">Performance</span>
    </div>
  );
};
